import placeholder from "./placeholder.png";

export default {
  placeholder
};



// WEBPACK FOOTER //
// ./src/assets/images/mhi/index.js